import React, { Component } from 'react';
import _ from 'lodash'

import allCandidates from './data/candidates'
import partyOpinions from './data/partyOpinions'
import questions from './data/questions'
import icons from './icons'
import CandidateCard from './CandidateCard'

import { setState } from './lib/state'
import { updatePath } from './lib/path'
import t from './translate/t'

for (const district in allCandidates) {
    allCandidates[district] = _.shuffle(allCandidates[district])
}

const districts = Object.keys(allCandidates).sort()

class Quiz extends Component {
  state = {
    showResults: 20,
    partiesShown: 5,
    stats: {
        averageTime: 41.3,
        completedCount: 36397,
    },
  }

  componentDidMount() {
    return
    fetch("/analytics/stats", {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: "GET",
    })
      .then(result => result.json())
      .then(stats => {
        this.setState({ stats })
      })
      .catch(console.error)
  }

  setDistrict(district) {
    setState({ district })

    updatePath(district)
  }

  answer(event, question, opinion) {
    const { answers } = this.props

    answers.push({
        question,
        opinion,
    })

    setState({ answers })

    updatePath(this.props.district, answers)
  }

  setWeightedOpinion(item) {
    const weightedOpinion = item.question || false
    setState({ weightedOpinion })

    updatePath(this.props.district, this.props.answers, weightedOpinion, true)
  }

  filter(key, value) {
    const { filters } = this.props

    if (filters[key].includes(value)) {
        filters[key] = filters[key].filter(existing => existing !== value)
    } else {
        filters[key].push(value)
    }

    setState({ filters })
  }

  render() {
    const { answers, weightedOpinion, district, filters, language } = this.props
    const { stats } = this.state

    const footer = <div className="py-8 px-2 text-center">
      <h3>{t('contact')}:</h3>
      <p className="mb-8 text-lg"><a href="mailto:info@pikavaalikone.fi">info@pikavaalikone.fi</a> {t('or')} <a href="https://twitter.com/hannujkola">@hannujkola</a></p>
      <p>{t('privacy')} <span className="link" onClick={() => setState({ noLogging: true })}>{t('clickhere')}</span>.</p>
    </div>

    if (!district) {
      const statsAvailable = stats && stats.completedCount

        return <div>
            <div className="py-2">
                <p className="px-2">{t('info0')}</p>
                <p className="px-2"><a href={t('infoUrl')}>{t('info2')}</a></p>

                <p className="px-2 font-bold text-sm text-center my-8 h-4">{statsAvailable ?
                  language === 'fi'
                    ? <span>Vaalikoneen on tehnyt jo {stats.completedCount} kävijää. Vastaamiseen kului keskimäärin {stats.averageTime} sekuntia.</span>
                    : <span>{stats.completedCount} visitors have completed the compass. Average answer time was {stats.averageTime} seconds.</span>
                : ''}</p>
            </div>

            <div className="bg-light pt-4 pb-2 px-2">
                <h2 className="text-center">{t('begin')}:</h2>
                {districts.map(district => {
                    return <div
                        key={district}
                        className="card card-hover mb-2 py-2 text-center text-lg"
                        onClick={() => this.setDistrict(district)}
                    >
                        {district}
                    </div>
                })}
            </div>
            {footer}
        </div>
    } else if (process.env.SSR) {
      return null
    }

    const question = questions[answers.length]

    const back = <div className="py-8 text-center">
        <span
            className="link"
            onClick={event => window.history.back()}
        >
            {t('back')}
        </span>
    </div>

    if (question) {
        return <div className="quiz-container">
            <div className="w-full">
                <h2 className="mb-8">{t(question.id)}</h2>
                <div className="text-center">
                    <div className="flex flex-row -mx-2 mb-8">
                        {question.answers.map(answer => {
                            return <div
                                className="card card-hover text-center py-4 flex-1 mx-2 px-2"
                                key={question.id + '-' + answer.value}
                                onClick={event => this.answer(event, question.id, answer.value)}
                            >{t(answer.name)}</div>
                        })}
                    </div>
                    <div>
                        <span
                            key={question.id + '-skip'}
                            className="card card-hover py-4 mx-auto px-2"
                            style={{ minWidth: "49%", display: 'inline-block' }}
                            onClick={event => this.answer(event, question.id, 0)}
                        >
                            {t('skip')}
                        </span>
                    </div>
                    {back}
                </div>
            </div>
        </div>
    }

    const opinions = answers.filter(answer => answer.opinion !== 0)

    if (weightedOpinion === undefined && opinions.length >= 2) {
        return <div className="quiz-container">
            <div className="w-full">
                <h2>{t('most important')}</h2>
                {opinions.map((opinion, index) => {
                    return <div
                        key={index}
                        className="card card-hover text-center mb-2 py-2" onClick={() => this.setWeightedOpinion(opinion)}
                    >
                        {t(opinion.question)}
                    </div>
                })}
                <div
                    className="card card-hover text-center py-2 mt-4"
                    onClick={() => this.setWeightedOpinion(false)}
                >
                    {t('skip')}
                </div>
                {back}
            </div>
        </div>
    }

    const candidates = []
    let minOpinionDifference = 100
    allCandidates[district].forEach(candidate => {
        let opinionDifference = 0
        let score = 0
        let differentOpinions = []

        for (const answer of opinions) {
            let opinion = answer.opinion

            if (weightedOpinion && answer.question === weightedOpinion) {
                opinion *= 1.5
            }

            for (const question of candidate.questions) {
                if (answer.question === question.id) {
                    const difference = getDifference(opinion, question.opinion)

                    opinionDifference += difference
                    if (difference <= .75) {
                        score++
                    } else {
                        differentOpinions.push(question.id)
                    }
                }
            }
        }

        const percentage = score / opinions.length

        if (percentage <= .5) {
            return
        }

        if (opinionDifference < minOpinionDifference) {
            minOpinionDifference = opinionDifference
        }

        candidates.push({
            opinionDifference,
            perfectMatch: score === opinions.length,
            percentage,
            candidate,
            differentOpinions,
        })
    })

    const ageGroups = _.uniq(candidates.map(item => item.candidate.ageGroup)).filter(exists => exists).sort()
    const genders = _.uniq(candidates.map(item => item.candidate.gender)).filter(exists => exists)

    let filteredResults = candidates.filter(item => {
        if (filters.ageGroup.length && !filters.ageGroup.includes(item.candidate.ageGroup)) {
            return
        }
        if (filters.gender.length && !filters.gender.includes(item.candidate.gender)) {
            return
        }

        return true
    })

    let parties = []

    _.uniq(filteredResults.map(result => result.candidate.party)).forEach(party => {
        if (!partyOpinions[party]) {
            return
        }

        let opinionDifference = 0

        for (const answer of opinions) {
            let opinion = answer.opinion

            if (weightedOpinion && answer.question === weightedOpinion) {
                opinion *= 1.5
            }

            const difference = getDifference(opinion, partyOpinions[party][answer.question])
            opinionDifference += difference
        }

        parties.push([party, opinionDifference])
    })

    parties = _.sortBy(parties, item => item[1]).map(party => party[0])

    filteredResults = filteredResults.filter(item => {
        if (filters.party.length && !filters.party.includes(item.candidate.party)) {
            return
        }

        return true
    })

    filteredResults = _.sortBy(filteredResults, item => parties.indexOf(item.candidate.party))
    filteredResults = _.sortBy(filteredResults, 'opinionDifference')
    filteredResults = _.sortBy(filteredResults, opinion => !opinion.perfectMatch)

    const perfectResultsCount = filteredResults.filter(result => result.perfectMatch).length

    let title
    let helpText = t('resultshelp')
    if (perfectResultsCount) {
        title = `${perfectResultsCount} ${t("matching")} ${t("candidates")}`
    } else if (filteredResults.length) {
        title = `0 ${t("matching")} ${t("candidates")}, ${filteredResults.length} ${t("other")} ${t("candidates")}`
    } else {
        title = `0 ${t("candidates")}`
    }

    if (opinions.length === 0) {
        title = `${perfectResultsCount} ${t("candidates")}`
        filteredResults = _.sortBy(filteredResults, item => item.candidate.number)
        helpText = t('noopinions')
    }

    return <div className="flex-1 bg-light pt-2 pb-4 px-2">
        <div className="text-center my-6">
            <span
                className="button text-lg"
                onClick={event => window.history.back()}
            >
                {t('change')}
            </span>
        </div>
        <div className="text-sm mt-2 mb-8">
            <h3>{t('Filter results')}</h3>
            <div className="flex flex-row -mx-2 mb-2">
                <div className="flex-1 mx-2">
                    <h4>{t('Age')}</h4>
                    <div className="-mx-1">
                        {ageGroups.map(value => {
                            const selected = filters.ageGroup.includes(value)
                            return <span key={value} className={"filter-value mx-2 " + (selected && 'selected')} onClick={() => this.filter('ageGroup', value)}>
                                {value} {selected && <span><span dangerouslySetInnerHTML={{ __html: icons.close }} /></span>}
                            </span>
                        })}
                    </div>
                </div>
                <div className="flex-1 mx-2">
                    <h4>{t('Gender')}</h4>
                    <div className="-mx-1">
                        {genders.map(value => {
                            const selected = filters.gender.includes(value)
                            return <span key={value} className={"filter-value mx-2 " + (selected && 'selected')} onClick={() => this.filter('gender', value)}>
                                {t(value)} {selected && <span><span dangerouslySetInnerHTML={{ __html: icons.close }} /></span>}
                            </span>
                        })}
                    </div>
                </div>
            </div>
            <h4>{t('Party')}</h4>
            <div className="-mx-1">
                {_.take(parties, this.state.partiesShown).map(value => {
                    const selected = filters.party.includes(value)
                    return <span key={value} className={"filter-value mx-2 " + (selected && 'selected')} onClick={() => this.filter('party', value)}>
                        {value} {selected && <span dangerouslySetInnerHTML={{ __html: icons.close }} />}
                    </span>
                })}
                {parties.length > this.state.partiesShown && <div className="text-center" onClick={() => this.setState({ partiesShown: 100 })}>{t('show more parties')}</div>}
            </div>
        </div>
        <h2>{title}</h2>
        <p className="text-center text-sm">{helpText}</p>

        {filteredResults && _.take(filteredResults, this.state.showResults).map((result, i) => {
            if (!result.perfectMatch && filteredResults[i - 1] && filteredResults[i - 1].perfectMatch) {
                return <div key={result.candidate.number}>
                    <h2>{`${filteredResults.length - perfectResultsCount} ${t("other")} ${t("candidates")}`}:</h2>
                    <CandidateCard
                        {...result}
                    />
                </div>
            }

            return <CandidateCard
                key={result.candidate.number}
                {...result}
            />
        })}
        {filteredResults.length > this.state.showResults && <div className="text-center" onClick={() => this.setState({ showResults: this.state.showResults + 20 })}>{t('show more')}</div>}

        {footer}
    </div>
  }
}

function getDifference(a,b) {
    return Math.abs(a-b)
}

export default Quiz;
